<template>
  <div
    data-family="box"
    :data-type="type"
    :data-multiple="type === 'checkbox'"
    data-empty="true"
    :data-disabled="disabled ? 'true' : undefined"
  >
    <fieldset>
      <ul>
        <li
          v-for="(optionLabel, option) in displayedOptions"
          :key="option"
          :data-disabled="disabled ? 'true' : undefined"
          :data-testid="'productlist_filter_value_' + option"
          class="mb-2 mt-2"
        >
          <div class="form-check">
            <PrimeVueRadioButton
              v-if="type === 'radio'"
              :model-value="value?.[0]"
              :input-id="('productlist_filter_id_' + option).replace(/\s/g, '')"
              :value="option"
              :disabled="disabled"
              size="small"
              @change="handleChange(name, option.toString())"
            />
            <PrimeVueCheckbox
              v-else-if="type === 'checkbox'"
              :model-value="value"
              :input-id="('productlist_filter_id_' + option).replace(/\s/g, '')"
              :value="option"
              :disabled="disabled"
              size="small"
              @change="handleChange(name, option.toString())"
            />
            <label
              :for="('productlist_filter_id_' + option).replace(/\s/g, '')"
              class="p-label"
              >{{ optionLabel }}</label
            >
          </div>
        </li>
      </ul>
    </fieldset>
  </div>

  <LinkElement
    v-if="isMoreThanBorder"
    :link="''"
    :title="buttonText"
    :target-blank="false"
    icon-type="icon-left"
    :icon-name="!showLess ? 'chevron-up' : 'chevron-down'"
    class="mt-2"
    :disabled="disabled"
    @click="() => (showLess = !showLess)"
    >{{ buttonText }}</LinkElement
  >
</template>
<script setup lang="ts">
import { LinkElement } from '@hypercodestudio/basler-components';
import { toggleValuesInList } from '~/stores/productFilterStore/helper/toggleValuesInList';

type Props = {
  type: 'checkbox' | 'radio';
  label: string;
  name: string;
  value: string[] | undefined;
  options: { [key: string]: string };
  showMoreLabel?: string;
  showLessLabel?: string;
  displayedOptions?: number;
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  displayedOptions: undefined,
  showMoreLabel: 'show more',
  showLessLabel: 'show less'
});

const emits = defineEmits<{
  change: [code: string, newValue: string | string[]];
}>();

const isMoreThanBorder = computed(() =>
  props.displayedOptions
    ? Object.values(props.options).length > props.displayedOptions
    : false
);
const showLess = ref<boolean>(true);

const displayedOptions = computed(() => {
  if (showLess.value && isMoreThanBorder.value) {
    return Object.fromEntries(
      Object.entries(props.options).slice(0, props.displayedOptions)
    );
  }

  return props.options;
});

const buttonText = computed(() =>
  showLess.value ? props.showMoreLabel : props.showLessLabel
);

function handleChange(name: string, value: string) {
  if (props.type === 'radio') {
    emits('change', name, value);

    return;
  }
  emits('change', name, toggleValuesInList(props.value, value));
}
</script>
